(function(){
  const candle=document.getElementById('candle');
  if(candle){
    let dragging=false,startX=0,startY=0,startLeft=0,startTop=0;
    const start=(x,y)=>{dragging=true;candle.classList.add('is-dragging');startX=x;startY=y;startLeft=candle.offsetLeft;startTop=candle.offsetTop;};
    const move=(x,y)=>{if(!dragging)return;candle.style.left=(startLeft+x-startX)+'px';candle.style.top=(startTop+y-startY)+'px';candle.style.right='auto';candle.style.bottom='auto';};
    const end=()=>{dragging=false;candle.classList.remove('is-dragging');};
    candle.addEventListener('mousedown',e=>{start(e.clientX,e.clientY);e.preventDefault();});
    document.addEventListener('mousemove',e=>move(e.clientX,e.clientY));
    document.addEventListener('mouseup',end);
    candle.addEventListener('touchstart',e=>{if(!e.touches[0])return;start(e.touches[0].clientX,e.touches[0].clientY);},{passive:true});
    document.addEventListener('touchmove',e=>{if(!e.touches[0])return;move(e.touches[0].clientX,e.touches[0].clientY);},{passive:true});
    document.addEventListener('touchend',end);
  }

  const toggle=document.querySelector('[data-menu-toggle]');
  const drawer=document.querySelector('.mobile-menu');
  const backdrop=document.querySelector('.mobile-menu-backdrop');
  const closers=document.querySelectorAll('[data-menu-close]');
  const body=document.body;
  function openMenu(){
    if(!drawer||!toggle)return;
    drawer.classList.add('is-open');
    backdrop?.classList.add('is-open');
    toggle.classList.add('is-open');
    toggle.setAttribute('aria-expanded','true');
    drawer.setAttribute('aria-hidden','false');
    body.classList.add('menu-open');
  }
  function closeMenu(){
    if(!drawer||!toggle)return;
    drawer.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
    toggle.classList.remove('is-open');
    toggle.setAttribute('aria-expanded','false');
    drawer.setAttribute('aria-hidden','true');
    body.classList.remove('menu-open');
  }
  toggle?.addEventListener('click',()=>drawer?.classList.contains('is-open')?closeMenu():openMenu());
  closers.forEach(el=>el.addEventListener('click',closeMenu));
  drawer?.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeMenu();});

  document.querySelectorAll('.tilt').forEach(card=>{
    card.addEventListener('mousemove',e=>{
      if(window.matchMedia('(max-width: 900px)').matches)return;
      const r=card.getBoundingClientRect(),x=e.clientX-r.left,y=e.clientY-r.top;
      card.style.transform='perspective(1000px) rotateX('+((y-r.height/2)/r.height*-5)+'deg) rotateY('+((x-r.width/2)/r.width*5)+'deg) translateY(-2px)';
    });
    card.addEventListener('mouseleave',()=>{card.style.transform='perspective(1000px) rotateX(0) rotateY(0) translateY(0)';});
  });

  const reveals=document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('visible');observer.unobserve(entry.target);}});},{threshold:0.12});
    reveals.forEach(el=>observer.observe(el));
  }else{reveals.forEach(el=>el.classList.add('visible'));}

  document.querySelectorAll('.tab-h').forEach(h=>{h.addEventListener('click',function(){this.parentElement.classList.toggle('open');});});
})();
